import { createStore } from 'jotai';

const pageStore = createStore();
const componentStores = new Map<string, any>();

function getStore(id: string) {
  if (!componentStores.has(id)) {
    componentStores.set(id, createStore());
  }

  return componentStores.get(id);
}

export function useComponentStore(storeId: string) {
  return getStore(storeId);
}

export function usePageStore() {
  return pageStore;
}
